import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireSelectionProjet.module.scss';

const FormulaireSelectionProjet = ({
  preconfigurerProjetId,
  gererProjetId,
  affichageProfil,
}) => {
  // Replace mapStateToProps with useSelector
  const listeProjets = useSelector((state) => state.authentifie.projects_list);
  const premier_valeur_filtre_projet = useSelector(
    (state) => state.authentifie.filtre_projects_list_id[0]
  );

  // State management with useState
  const [projetId, setProjetId] = useState(null);

  // Replace componentDidMount and componentDidUpdate with useEffect
  useEffect(() => {
    if (preconfigurerProjetId !== undefined && preconfigurerProjetId !== null) {
      setProjetId(preconfigurerProjetId);
    } else if (projetId === undefined || projetId === null) {
      setProjetId(premier_valeur_filtre_projet);
      gererProjetId(premier_valeur_filtre_projet);
    }
  }, [preconfigurerProjetId, premier_valeur_filtre_projet, gererProjetId]);

  // Event handlers
  const handleProjetIdChange = (event) => {
    const value = event.target.value;
    if (value === '-1' || value === -1) {
      setProjetId(null);
    } else {
      setProjetId(value);
    }
    gererProjetId(value);
  };

  return (
    <>
      <label className={styles.label} htmlFor="inlineFormCustomSelect">
        {checkMot('projet')}
      </label>
      <select
        className={[s.custom_select, styles.text_geral, s.card_body].join(' ')}
        onChange={handleProjetIdChange}
        disabled={affichageProfil === true}
        value={projetId || ''}
      >
        <option value="" disabled>
          Sélectionner un projet
        </option>
        {Object.entries(listeProjets).map(([_, project]) => (
          <option key={project.project_id} value={project.project_id}>
            {`id: ${project.project_id}, name: ${project.project_name}`}
          </option>
        ))}
      </select>
    </>
  );
};

export default FormulaireSelectionProjet;
